import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Tabs, Tab } from "carbon-components-react";
import db from "../../table.json";
import "./styles.css";

import tabela from "../../assets/tabelaTeste.png";

const useStyles = makeStyles((theme) => ({
  indicator: {
    backgroundColor: "green",
    height: "10px",
    top: "45px",
  },
}));

const TabsRapicare = () => {
  const classes = useStyles();

  return (
    <div style={{ width: "100%" }}>
      <Tabs
        scrollIntoView={false}
        type="container"
        indicatorColor="primary"
        classes={{ indicator: classes.indicator }}
        TabIndicatorProps={{
          style: { background: "cyan", height: "10px", top: "35px" },
        }}
      >
        <Tab href="#" id="tab-1" label="Tabela Rapicare">
          <div className="wrapper">
            <div style={{ margin: 10 }}>
              <h3>Table with colgroup</h3>
              <table className="border-rapicare" style={{ width: "50%" }}>
                <colgroup span="4" class="columns"></colgroup>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Language</th>
                </tr>
                {db.length > 0 &&
                  db.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.type}</td>
                      <td>{item.language}</td>
                    </tr>
                  ))}
                {db.length === 0 && (
                  <tr>
                    <td> - </td>
                    <td> - </td>
                    <td> - </td>
                  </tr>
                )}
              </table>
            </div>
            <div style={{ margin: 10 }}>
              <h3>Arquivo de referência</h3>
              <img src={tabela} />
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default TabsRapicare;
